import * as variables from './variables.js';

import './lib/AnimationEasing';

import {Analytics, GoogleAnalytics, FacebookPixel, LinkedInInsight, GoogleAnalyticsEventObserver} from '@plaudit/analytics';
const analytics = Analytics.getInstance();
const googleAnalytics = analytics.getTracker(GoogleAnalytics.platformName) as GoogleAnalytics;
const facebookPixel = analytics.getTracker(FacebookPixel.platformName) as FacebookPixel;
const linkedInInsight = analytics.getTracker(LinkedInInsight.platformName) as LinkedInInsight;

if (googleAnalytics !== null) {
	// Goal: Contact Form - Success
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2027513);
			},
			{
				eventCategory:	(value: string) => value === "Contact Form",
				eventAction:	(value: string) => value === "Submit"
			}
		)
	);

	// Goal: Order Form - Success (from landing page)
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2027513); // Using the "Contact Form - Success" conversion for this. 
			},
			{
				eventCategory:	(value: string) => value === "Place an Order Form",
				eventAction:	(value: string) => value === "Submit"
			}
		)
	);

	// Goal: Assessment Form - Success (from landing page)
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2027513); // Using the "Contact Form - Success" conversion for this.
			},
			{
				eventCategory:	(value: string) => value === "Assessment Form",
				eventAction:	(value: string) => value === "Submit"
			}
		)
	);

	// Goal: Email Link - Click
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2027521);
			},
			{
				eventCategory:	(value: string) => value === "Email Link",
				eventAction:	(value: string) => value === "Click"
			}
		)
	);

	// Goal: Telephone Link - Click
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2027529);
			},
			{
				eventCategory:	(value: string) => value === "Telephone Link",
				eventAction:	(value: string) => value === "Click"
			}
		)
	);

	// Goal: Download Link - Click
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
				if (linkedInInsight !== null) linkedInInsight.trackConversion(2027537);
			},
			{
				eventCategory:	(value: string) => value === "Download Link",
				eventAction:	(value: string) => value === "Click"
			}
		)
	);
}

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Slick Carousel used for Testimonial Carousel
// import slickCarousel from './component/SlickCarousel';
// slickCarousel();

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

// @ts-ignore
var Accordion = require('./component/Accordion.js');
var faqsAccordion = new Accordion({
	scope: '.faqs'
});
faqsAccordion.activate();

import featureCarousel from './component/FeatureCarousel';
const entryCarouselEl = document.querySelector('.__entry .featureCarousel') as HTMLElement;
if (entryCarouselEl) {
	const entryCarousel = new featureCarousel({
		analyticsCategory: 'Feature Carousel',
		carouselClass: 'featureCarousel',
		carouselEl: entryCarouselEl,
		duration: 7000,
		doIndicatorClick: true
	});
}

import productCarousel from './component/ProductCarousel';
const productCarouselEl = document.querySelector('.productCarousel') as HTMLElement;
if (productCarouselEl) {
	const myProductCarousel = new productCarousel({
		analyticsCategory: 'Product Carousel',
		carouselClass: 'productCarousel',
		carouselEl: productCarouselEl,
		duration: 3000,
		doIndicatorClick: true
	});
}

import testimonialStripe from './component/TestimonialStripe';
const testimonialStripeEl = document.querySelector('.testimonialStripe') as HTMLElement;
if (testimonialStripeEl) {
	const myTestimonialStripe = new testimonialStripe({
		analyticsCategory: 'Testimonial Stripe',
		carouselClass: 'testimonialStripe',
		carouselEl: testimonialStripeEl,
		doIndicatorClick: true
	});
}


// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;
import 'jquery-colorbox';

import VideoLightbox from './component/VideoLightbox';
VideoLightbox();

import ImageLightbox from './component/ImageLightbox';
ImageLightbox();
